export default {
  localFunctions: false,
  localFirestore: false,
  localAuth: false,
  localStorage: false,
  local: false,
  dev: true,
  prod: false,
  bucketBaseUrl: 'https://firebasestorage.googleapis.com/v0/b/leadgen-server-dev.appspot.com/o/',
  firebaseConfig: {
    apiKey: 'AIzaSyCqOlBNUyPx7oh7DcBcRZ3aO4g2sEn5eTU',
    authDomain: 'leadgen-server-dev.firebaseapp.com',
    projectId: 'leadgen-server-dev',
    storageBucket: 'leadgen-server-dev.appspot.com',
    messagingSenderId: '185348765148',
    appId: '1:185348765148:web:9c4fb556727d0cb0500b19',
    measurementId: 'G-JFSG6PL26C',
  },
  imgixBaseUrl: 'https://trade-mailer-dev.imgix.net/',
  stripeSecret:
    'pk_test_51QJMRfPvoAGPr3UKuh3CrOjvtV9C0sXMU6MGiydiJSfxQC1NyEs6wN3DDcCsxZYVIrWK9AKYOwFM7UhLudAbeR6J003wY1yz6e',
  idealPostcodesApiKey: 'ak_mloa5m5hXQclhcBKAfsZ3V5ZjwXcP',
  polotnoApiKey: 'Pw61VRNK3Ub2BYw6Tvyw',
  whatsappUrl: 'https://wa.me/447984464429',
}
